import { select, call, put } from "redux-saga/effects";
import Modal from "@bitComponents/unifiedComponents/Modal";
import { registerShopper as registerShopperBit } from "../bitSagas/registerShopper";
import { validateShopper as validateShopperBit } from "../bitSagas/validateShopper";
import { isRegisteredShopper as isRegisteredShopperBit } from "../bitSagas/isRegisteredShopper";
import { actions as loaderControlActions } from "../reducers/loaderControl";
import { megaMinderStatus } from "../minder/MegaMinder/megaMinderStatus";
import { STRING_KEYS } from "../localizedStrings";
import { showRegisterOTPModal } from "../modals/registerOtpModal";
import { WEBSERVICE_ERRORS } from "../errorManagement/errorCatalog";
import { actions as uiNeedsActions } from "../reducers/uiNeeds";
import { commonActions } from "../reducers/common";

const apisNeedsStore = (state) => state.apiNeeds;
const localizedStringsStore = (state) => state.localizedStrings;
const getErrorManagement = (state) => state.errorManagement;
const flowStore = state => state.flow;

export function* registerShopper(input) {
  const apisNeeds = yield select(apisNeedsStore);
  const { register } = apisNeeds;
  const { inputs } = register;
  const { showError, normalizeHttpErrors, data } = input;
  const { requestNewPin } = { ...data };
  const reduxUpdate = {
    successUpdate: null,
    errorUpdate: showError,
  };

  const {
    name,
    firstSurname,
    secondSurname,
    documentType,
    documentNumber,
    nationality,
    contactPhone,
    email,
  } = inputs;

  const registerShopperParams = {
    name,
    firstSurname,
    secondSurname,
    documentType,
    documentNumber,
    nationality,
    contactPhone,
    email,
    reduxUpdate,
    normalizeHttpErrors,
  };

  const { localizedStrings } = yield select(localizedStringsStore);
  if (!requestNewPin) {
    yield put(
      loaderControlActions.setLoaderState({
        loading: true,
        loadingText: localizedStrings[STRING_KEYS.waitingPageTexts.register],
      })
    );
  }
  try {
    yield call(registerShopperBit, registerShopperParams);
    yield put(
      loaderControlActions.setLoaderState({
        loading: false,
      })
    );
    showRegisterOTPModal(contactPhone);
  } catch (error) {
    const errorResponse = megaMinderStatus.KO;
    errorResponse.errorInfo = error;

    return errorResponse;
  }
}

export function* validateShopper(input) {
  const { showError, normalizeHttpErrors, pin } = input;
  const reduxUpdate = {
    successUpdate: null,
    errorUpdate: showError,
  };
  try {
    const validateShopperParams = {
      pin,
      reduxUpdate,
      normalizeHttpErrors,
    };

    yield call(validateShopperBit, validateShopperParams);
    Modal.hide();
    const { flowJson } = yield select(flowStore);
    if(flowJson.registeredShopperContinueStep){
      yield put(commonActions.setConfirmedStep({ stepId: flowJson.registeredShopperContinueStep }));
    }
  } catch (error) {
    const { handledErrors } = yield select(getErrorManagement);
    if (error.status === 415) {
      Modal.hide();
      const { host, protocol } = window.location;
      const protocolTrimmed = protocol.split(":")[0];
      const buyProcessUrlComposedToSeth = encodeURIComponent(
        window.location.href
      );
      const loginUrlComposed = `${protocolTrimmed}://${host}/auth/login?redirect=${buyProcessUrlComposedToSeth}`;
      yield put(
        showError({
          ...handledErrors.BUSINESS_ERRORS.GO_LOGIN,
          errorInfo: {
            ...handledErrors.BUSINESS_ERRORS.GO_LOGIN.errorInfo,
            buttons: [
              {
                ...handledErrors.BUSINESS_ERRORS.GO_LOGIN.errorInfo.buttons[0],
                link: loginUrlComposed,
              },
            ],
          },
        })
      );
    } else if (error.status === 401) {
      yield put(showError(handledErrors.BUSINESS_ERRORS.CLIENT_ADVICE));
    } else {
      const { response } = error;

      if (
        response &&
        response.status === "KO" &&
        response.error &&
        response.error.codigoErrorNegocio
      ) {
        switch (response.error.codigoErrorNegocio) {
          case WEBSERVICE_ERRORS.OTP_INCORRECT:
          case WEBSERVICE_ERRORS.OTP_INVALID:
            yield put(uiNeedsActions.incorrectValidationPin());
            break;
          case WEBSERVICE_ERRORS.OTP_EXPIRED:
          case WEBSERVICE_ERRORS.OTP_MAX_RETRIES_REACHED:
            yield put(uiNeedsActions.validationPinExpired());
            break;
          default:
            Modal.hide();
            break;
        }
      }
    }
  }
}

export function* isRegisteredShopper() {
  try {
    const response = yield call(isRegisteredShopperBit);
    const { registrado: isRegistered } = response.datos;
    return isRegistered;
  } catch (error) {
    return false;
  }
}
